<template>
  <div class="container VisualizarImagem mb-5">
    <div class="row">
      <div class="col-4">
        <div class="row">
          <div class="col">
            <label class="label">Visualizar por:</label>
          </div>
        </div>

        <div class="row">
          <div class="col">
            <div class="form-group">
              <div>
                <span class="custom-control custom-radio custom-control-inline">
                  <input id="tipo_documento"
                         v-model="imagem.tipo"
                         class="custom-control-input"
                         name="documento"
                         value="documento"
                         checked="checked"
                         type="radio"
                         @keyup.enter="imagem.tipo = 'documento'">
                  <label class="custom-control-label"
                         for="tipo_documento">
                    Tipo de documento
                  </label>
                </span>
              </div>
              <div>
                <span class="custom-control custom-radio custom-control-inline">
                  <input id="tipo_correspondente"
                         v-model="imagem.tipo"
                         class="custom-control-input"
                         name="correspondente"
                         value="correspondente"
                         type="radio"
                         @keyup.enter="imagem.tipo = 'correspondente'">
                  <label class="custom-control-label"
                         for="tipo_correspondente">
                    Correspondente
                  </label>
                </span>
              </div>
            </div>
          </div>
        </div>

        <div class="row pl-2 pr-2">
          <div class="col VisualizarImagem--border">
            <div class="row">
              <div class="col VisualizarImagem--header pt-1 pb-1">
                E-habilitação
              </div>
            </div>
            <div v-show="imagem.tipo == 'documento'">
              <collapse-default id="collapse_comum"
                                :style-default="false"
                                :collapse-visible="compDocumentos('Comum').length != 0"
                                icon-position="left">
                <template v-slot:header>
                  <strong> Comum</strong>{{ compDocumentos('Comum').length == 0 && ' - Sem documento' || null }}
                </template>

                <template v-slot:content>
                  <div v-for="(document, index) of compDocumentos('Comum')"
                       :key="`document_${ index }`"
                       class="VisualizarImagem--cursor"
                       :class="{'text-primary': (document && document.url_s3) == (visualizador && visualizador.url_s3)}"
                       @click="getPdf(document)">
                    {{ getName(document.tag) }}
                  </div>
                </template>
              </collapse-default>

              <collapse-default id="collapse_certidoes"
                                :style-default="false"
                                :collapse-visible="compDocumentos('Certidões').length != 0"
                                icon-position="left">
                <template v-slot:header>
                  <strong> Certidões </strong>{{ compDocumentos('Certidões').length == 0 && ' - Sem documento' || null }}
                </template>

                <template v-slot:content>
                  <div v-for="(document, index) of compDocumentos('Certidões')"
                       :key="`document_${ index }`"
                       class="VisualizarImagem--cursor"
                       :class="{'text-primary': (document && document.url_s3) == (visualizador && visualizador.url_s3)}"
                       @click="getPdf(document)">
                    {{ getName(document.tag) }}
                  </div>
                </template>
              </collapse-default>
            </div>

            <div v-show="imagem.tipo == 'correspondente'">
              <collapse-default id="collapse_correspondente_ambos"
                                :style-default="false"
                                :collapse-visible="compCorrespondentes('Ambos').length != 0"
                                icon-position="left">
                <template v-slot:header>
                  <strong> Ambos</strong>{{ compCorrespondentes('Ambos').length == 0 && ' - Sem documento' || null }}
                </template>

                <template v-slot:content>
                  <div v-for="(document, index) of compCorrespondentes('Ambos')"
                       :key="`document_correspondente_${ index }`"
                       class="VisualizarImagem--cursor"
                       :class="{'text-primary': (document && document.url_s3) == (visualizador && visualizador.url_s3)}"
                       @click="getPdf(document)">
                    {{ getName(document.tag) }}
                  </div>
                </template>
              </collapse-default>

              <collapse-default id="collapse_correspondente_conjuge1"
                                :style-default="false"
                                :collapse-visible="compCorrespondentes('Cônjuge 1').length != 0"
                                icon-position="left">
                <template v-slot:header>
                  <strong> Cônjuge 1</strong>{{ compCorrespondentes('Cônjuge 1').length == 0 && ' - Sem documento' || null }}
                </template>

                <template v-slot:content>
                  <div v-for="(document, index) of compCorrespondentes('Cônjuge 1')"
                       :key="`document_correspondente_${ index }`"
                       class="VisualizarImagem--cursor"
                       :class="{'text-primary': (document && document.url_s3) == (visualizador && visualizador.url_s3)}"
                       @click="getPdf(document)">
                    {{ getName(document.tag) }}
                  </div>
                </template>
              </collapse-default>

              <collapse-default id="collapse_correspondente_conjuge2"
                                :style-default="false"
                                :collapse-visible="compCorrespondentes('Cônjuge 2').length != 0"
                                icon-position="left">
                <template v-slot:header>
                  <strong> Cônjuge 2</strong>{{ compCorrespondentes('Cônjuge 2').length == 0 && ' - Sem documento' || null }}
                </template>

                <template v-slot:content>
                  <div v-for="(document, index) of compCorrespondentes('Cônjuge 2')"
                       :key="`document_correspondente_${ index }`"
                       class="VisualizarImagem--cursor"
                       :class="{'text-primary': (document && document.url_s3) == (visualizador && visualizador.url_s3)}"
                       @click="getPdf(document)">
                    {{ getName(document.tag) }}
                  </div>
                </template>
              </collapse-default>
            </div>
          </div>
        </div>
      </div>

      <div class="col">
        <div class="row pr-2">
          <div class="col VisualizarImagem--border">
            <div class="row">
              <div class="col VisualizarImagem--header pt-1 pb-1">
                {{ visualizador && getName(visualizador.tag) || 'Nenhum documento' }}
                <span v-if="visualizador && !visualizador.obrigatorio && !visualizador.tag.match('_sofia')"
                      v-b-modal="`modal-editar-doc`"
                      class="VisualizarImagem--cursor ml-4">
                  <icon-svg icon="pencil"
                            class="icons--white icon--xs" />
                </span>
                <span v-if="visualizador && !visualizador.tag.match('_sofia')"
                      class="VisualizarImagem--cursor ml-4"
                      @click="deleteDoc()">
                  <icon-svg icon="trash"
                            class="icons--red icon--xs" />
                </span>
              </div>
            </div>
            <div class="row">
              <object v-if="urlPdf != null"
                      class="document-preview embed-responsive"
                      :data="urlPdf"
                      type="application/pdf">
                <p>Seu browser não suporta arquivos pdf diretamente ou este arquivo não existe. Você pode tentar efetuar o download clicando.</p>
              </object>
            </div>
          </div>
        </div>
      </div>

      <b-modal v-if="visualizador"
               id="modal-editar-doc"
               ref="modal-editar-doc"
               centered
               title="Editar"
               @hidden="cancelEdit">
        <div class="AdicionarImagem--border">
          <div class="row p-2">
            <div class="col">
              <div class="row">
                <div class="col-4">
                  <div class="form-group">
                    <label for="imagem_tipo_documento"
                           class="label">
                      Tipo de Documento
                    </label>

                    <select id="imagem_tipo_documento"
                            v-model="visualizador.tipo_documento"
                            v-validate="`required`"
                            name="editar_tipo_documento"
                            :class="{ 'is-invalid': errors.has('editar_tipo_documento') }"
                            class="form-control form-control-sm">
                      <option :value="null">
                        Selecione o tipo
                      </option>
                      <option>Comum</option>
                      <option>Certidões</option>
                    </select>
                  </div>
                </div>
                <div class="col-4">
                  <div class="form-group">
                    <label for="imagem_tag"
                           class="label">Tag</label>
                    <input id="imagem_tag"
                           v-model="visualizador.tag"
                           v-validate="`required`"
                           name="editar_tag"
                           :class="{ 'is-invalid': errors.has('editar_tag') }"
                           type="text"
                           class="form-control form-control-sm">
                  </div>
                </div>
                <div class="col-4">
                  <div class="form-group">
                    <label for="imagem_correspondente"
                           class="label">Correspondente a</label>

                    <select id="imagem_correspondente"
                            v-model="visualizador.correspondente"
                            v-validate="`required`"
                            name="editar_correspondente"
                            :class="{ 'is-invalid': errors.has('editar_correspondente') }"
                            class="form-control form-control-sm">
                      <option :value="null">
                        Selecione o correspondente
                      </option>
                      <option>Ambos</option>
                      <option>Cônjuge 1</option>
                      <option>Cônjuge 2</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <template slot="modal-footer">
          <div class="row">
            <div class="col text-right">
              <button class="btn btn-danger btn-sm"
                      @click="cancelEdit">
                Cancelar
              </button>

              <button class="btn btn-secondary btn-sm ml-2"
                      @click="editDoc()">
                Atualizar
              </button>
            </div>
          </div>
        </template>
      </b-modal>
    </div>
  </div>
</template>

<script>
  /* components */
  import CollapseDefault from "@/components/SofiaRei/Resumo/Collapses/CollapseDefault"

  /* services */
  import UploadTemporarioService from "@/services/Arquivos/UploadTemporarioService"
  import eHabilitacaoService from "@/services/Registros/Habilitacao/eHabilitacaoService"

  /* libraries */
  import moment from 'moment'

  export default {
    name: "VisualizarImagem",
    components: {
      CollapseDefault
    },
    props: {
      propDocumentos: {
        type: Array,
        default: () => []
      }
    },
    data () {
      return {
        imagem: {
          tipo: "documento"
        },
        visualizador: null,
        urlPdf: null
      }
    },
    watch: {
      propDocumentos () {
        this.init()
      }
    },
    mounted () {
      this.init()
    },
    methods: {
      init () {
        if (this.compDocumentos('Comum').length > 0) {
          const doc = { ...this.compDocumentos('Comum')[0] }
          this.getPdf(doc)
        } else if (this.compDocumentos('Certidões').length > 0) {
          const doc = { ...this.compDocumentos('Certidões')[0] }
          this.getPdf(doc)
        }
      },
      compDocumentos (tipo) {
        const order = (a, b) => {
          const diff = moment(a.created_at).diff(b.created_at, 'seconds')


          if (diff > 0) return 1
          if (diff < 0) return -1

          return 0
        }

        if (this.propDocumentos)
          return this.propDocumentos.filter(documento => documento.tipo_documento == tipo && (documento.url_s3 || documento.url_s3)).sort(order)
        else
          return null
      },
      compCorrespondentes (correspondente) {
        if (this.propDocumentos)
          return this.propDocumentos.filter(documento => documento.correspondente == correspondente && (documento.url_s3 || documento.url_s3))
        else
          return null
      },
      async getPdf (doc) {
        try {
          loader({ text: 'Carregando PDF...', active: true})
          let file = null

          if (!!doc.habilitacao_casamento_documento_id) {
            /* pegando pdf da AWS caso seja registro */
            file = await eHabilitacaoService.getPdfAws(doc.habilitacao_casamento_documento_id)
          } else if (!doc.habilitacao_casamento_documento_id && !doc.tag.match('_sofia')) {
            /* pegando pdf local caso seja rascunho */
            file = await UploadTemporarioService.getTemp(doc.url_s3)
          } else {
            /* disparando erro caso não exista */
            // throw "Não foi encontrado o caminho do pdf"
          }

          if (file) {
            let blob = new Blob([file], { type: 'application/pdf' })
            let url = window.URL.createObjectURL(blob)

            this.visualizador = { ...doc }

            this.urlPdf = url
          }
        } catch (e) {
          objSwal.error = {
            ...objSwal.error,
            title: 'Erro ao carregar PDF',
            text: `Erro ao carregar o ${doc.label}, adicione-o novamente.`
          }

          console.error('Erro ao carregar PDF em VisualizarImagem', e)

          Swal.fire(objSwal.error)

          this.$emit('onDeleteDoc', doc)
        } finally {
          loader({ active: false})
        }
      },
      cancelEdit () {
        this.visualizador = { ...this.propDocumentos.find(doc => doc.url_s3 == this.visualizador.url_s3) }
        this.$refs["modal-editar-doc"].hide()
      },
      editDoc () {
        this.$validator.validateAll().then(() => {
          this.$emit('onEditDoc', this.visualizador)
          this.$refs["modal-editar-doc"].hide()
        })
      },
      deleteDoc () {
        objSwal.question.title = `Deseja excluir '${this.getName(this.visualizador.tag) || ''}' ?`
        Swal.fire(objSwal.question).then(res => {
          if (res.value === true) {
            this.$emit('onDeleteDoc', this.visualizador)

            if (this.propDocumentos.length > 0) {
              // resetamos o visualizador
              this.visualizador = null
              this.urlPdf = null
            }
          }
        })
      },

      getName (tag) {
        const valores = {
          processo_autuacao_sofia: 'Processo autuação',
          processo_autuacao_assinado_sofia: 'Processo autuação',
          capa_sofia: 'Capa',
          memorial_sofia: 'Memorial',
          certidoes_sofia: 'Certidões',
          edital_proclamas_sofia: 'Edital Proclamas',
          outras_certidoes_sofia: 'Outras Certidões',
          cumprimento_sofia: 'Cumprimento',
          certidao_habilitacao_sofia: 'Certidão Habilitação'
        }

        return valores[tag] || tag
      }
    },
  }
</script>

<style scoped lang="scss">
  .label {
    font-size: 14px;
  }

  .VisualizarImagem {
    &--border {
      border: 1px solid black;
    }

    &--header {
      background-color: black;
      color: white;
    }

    &--cursor {
      cursor: pointer;
    }
  }

  .document-preview {
    height: 400px !important;
  }
</style>
